// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"g6-z"};